export default "__VITE_ASSET__BnGZgyLb__";